import {Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, ViewChild} from '@angular/core';
import {SendedFile} from '../../../model/SenderFile';

import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {UploadFileComponent} from "../upload-file/upload-file.component";

@Component({
    selector: 'app-mobile-response',
    templateUrl: './mobile-response.component.html',
    imports: [
    FaIconComponent,
    FormsModule,
    UploadFileComponent
],
    styleUrls: ['./mobile-response.component.css']
})
export class MobileResponseComponent {

  $hide = true;
  historySet = false;
  responseType = 'reponse';

  sendedFiles: SendedFile[] = [];

  @ViewChild('textarea') textarea: ElementRef;

  @Input() set hide(value: boolean) {
    this.$hide = value;
    if (!value && this.textarea !== undefined) {
      // Add history state to keep current page in case of "return" pressed
      history.pushState({}, '');
      this.historySet = true;
      this.renderer.addClass(document.body, 'overflow-hidden');
      setTimeout(() => {
        this.textarea.nativeElement.focus();
      });
    } else {
      this.setHide();
    }
  }

  @Output() hideChange = new EventEmitter<boolean>();
  @Output() response = new EventEmitter<{ body, filesIds }>();
  @Output() responseRelance = new EventEmitter<{ body, filesIds }>();
  @Output() responseClose = new EventEmitter<{ body, filesIds }>();

  body;

  constructor(private renderer: Renderer2) {
  }

  @HostListener('window:popstate')
  onPopState() {
    this.historySet = false;
    this.hide = true;
  }

  setHide(): void {
    if (this.historySet) {
      this.historySet = false;
      history.back();
    }
    this.$hide = true;
    this.renderer.removeClass(document.body, 'overflow-hidden');
    this.hideChange.emit(this.$hide);
  }

  doSend(): void {
    if (this.body) {
      const obj = {body: this.body.replaceAll('\n', '<br/>'), filesIds: this.sendedFiles.map(s => s.id)};
      if (this.responseType === 'reponse') {
        this.response.emit(obj);
      } else if (this.responseType === 'clore') {
        this.responseClose.emit(obj);
      } else {
        this.responseRelance.emit(obj);
      }
    }
  }

  autogrow(): void {
    this.textarea.nativeElement.style.height = 'auto';
    this.textarea.nativeElement.style.height = (this.textarea.nativeElement.scrollHeight + 28) + 'px';
  }

  deleteFile(f: SendedFile): void {
    const index = this.sendedFiles.indexOf(f, 0);
    if (index > -1) {
      this.sendedFiles.splice(index, 1);
    }
  }
}
